/**
 * Free-text hint an operator should see for a job's opportunity, in their own
 * locale. Hints are authored in German, so `de` is the fallback when there is
 * no translation for the current locale.
 *
 * Returns '' when there is no hint, so callers can `v-if` on the result.
 */
export function getOpportunityHint(opportunity, locale) {
  const hints = opportunity?.hints;
  if (!hints) {
    return '';
  }
  return hints[locale] || hints.de || '';
}
